export default __webpack_public_path__ + "static/media/india.40c8d26c.svg";